<!--
일괄기능 — 구매요청 「구매요청 메뉴에서 제거」 (TASK-161 사이클 12 결정 39-⑥)
------------------------------------
 - 선택 상품의 구매요청 메뉴 노출 기준일 (prods.buy_req_at) 을 비움 → 어느 탭·기간에도 나오지 않음 (배송단계 무변경)
 - 구매정보가 있는 상품은 제거 불가 (선택 항목 중 있으면 안내 + 확인 버튼 차단 — 서버 MenuVisibilityLogic 도 거부)
 - 다시 노출 = 상품상세 「구매요청 메뉴 노출설정」 ON (39-⑦) 또는 배송단계가 다시 구매요청으로 바뀔 때
 - POST /admin/buy-requests/removals → 성공 후 페이지 새로고침
-->
<template>
    <div uk-modal esc-close="false" bg-close="false" class="br-remove-modal">
        <div class="uk-modal-dialog uk-modal-body">
            <button class="uk-modal-close-default" type="button" uk-close></button>
            <h3 class="uk-modal-title">구매요청 메뉴에서 제거</h3>

            <p class="uk-text-primary br-remove-summary">
                선택한 상품 {{ targets.length }} 개를 구매요청 메뉴에서 제거합니다.
            </p>
            <ul class="uk-list uk-list-bullet uk-text-muted">
                <li>배송단계 · 상품 정보는 바뀌지 않습니다 (구매요청 목록에서만 빠집니다).</li>
                <li>다시 보이게 하려면 상품상세의 「구매요청 메뉴 노출설정」 에서 ON 으로 저장합니다.</li>
            </ul>

            <div v-if="hasOrderCount > 0" class="uk-text-danger br-remove-blocked">
                구매정보가 있는 상품 {{ hasOrderCount }}개가 포함되어 있습니다. 구매정보가 있는 상품은 제거할 수 없습니다.
            </div>

            <div class="uk-text-right uk-margin-top">
                <button class="uk-button uk-button-default uk-modal-close" type="button">닫기</button>
                <button class="uk-button uk-button-primary br-remove-submit" type="button" :disabled="busy || hasOrderCount > 0" @click="submit">
                    제거
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            /**
             * 일괄기능 공유data (BuyRequestIndexTrait::buyRequestBatchJson — has_buy_order 포함)
             */
            batch: Object,

            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {
                // 작업대상 아이템 (jobInit 시점 선택 상품)
                targets: [],

                busy: false,
            };
        },
        computed: {
            // 구매정보 있는 상품 수 (선차단 — 서버 거부와 별개)
            hasOrderCount() {
                return _.filter(this.targets, (item) => !! item.has_buy_order).length;
            },
        },
        methods: {
            // 작업초기화 (버튼 클릭 → 모달)
            jobInit() {
                this.targets = _.filter(this.batch.items, ['checked', true]);
                if (this.targets.length === 0) {
                    alert('선택된 상품이 없습니다.');
                    return;
                }

                UIkit.modal(this.$el).show();
            },

            submit() {
                if (this.busy || this.hasOrderCount > 0) {
                    return;
                }
                if (! confirm(this.targets.length + ' 개 상품을 구매요청 메뉴에서 제거합니다. 정말 실행합니까?')) {
                    return;
                }
                this.busy = true;

                $.app.ajax.module.default({
                    type: 'post',
                    url: '/admin/buy-requests/removals',
                    dataType: 'json',
                    data: {
                        _token: this.csrfToken,
                        prod_ids: _.map(this.targets, 'id'),
                    },
                    success: (response) => {
                        if (response && response.msg) {
                            alert(response.msg);
                        }
                        $.app.refresh();
                    },
                    complete: () => {
                        this.busy = false;
                    },
                });
            },
        },
    }
</script>

<style lang="scss" scoped>
    .br-remove-blocked {
        padding: 6px 10px;
        border-left: 4px solid #e0452a;
    }
</style>
